module.exports = __webpack_public_path__ + "img/img23.5749c9b5.svg";